type WarrantyReturnBalanceSource = {
  amount_to_collect?: number | null
  payments?: unknown[] | null
  original_job?: {
    invoice?: {
      id?: string | null
      balance_due?: number | null
    } | null
  } | null
}

type WarrantyReturnStopPath =
  | {
      path: 'collect'
      amount: number
      invoiceId?: string
      completeJobBeforeNextStep: false
    }
  | { path: 'report'; amount: 0; completeJobBeforeNextStep: false }

type WarrantyReturnPrimaryActionPath = WarrantyReturnStopPath['path']

function positiveMoney(value: number | null | undefined): number {
  return typeof value === 'number' && Number.isFinite(value)
    ? Math.max(value, 0)
    : 0
}

export function getWarrantyReturnBalance(
  job: WarrantyReturnBalanceSource
): number {
  const collectAmount = positiveMoney(job.amount_to_collect)
  if (collectAmount > 0) return collectAmount

  if (job.original_job) {
    return positiveMoney(job.original_job.invoice?.balance_due)
  }

  return 0
}

export function getWarrantyReturnStopPath(
  job: WarrantyReturnBalanceSource
): WarrantyReturnStopPath {
  const amount = getWarrantyReturnBalance(job)
  const invoiceId = job.original_job?.invoice?.id ?? undefined

  return amount > 0
    ? { path: 'collect', amount, invoiceId, completeJobBeforeNextStep: false }
    : { path: 'report', amount: 0, completeJobBeforeNextStep: false }
}

export function getWarrantyReturnPrimaryActionPath(
  job: WarrantyReturnBalanceSource
): WarrantyReturnPrimaryActionPath {
  if ((job.payments ?? []).length > 0) return 'report'

  return getWarrantyReturnStopPath(job).path
}

export function isWarrantyReturnNothingToPay(
  job: WarrantyReturnBalanceSource
): boolean {
  return getWarrantyReturnStopPath(job).path === 'report'
}
